const testimonials = [
  {
    id: 1,
    name: 'P. R. Gomes',
    title: 'Team Lead',
    org: 'MAS LEGATO',
    desc: 'Vihan is a person of commitment. He is really good at what he is doing. I really like his work. Especially the unique point of view of designing.',
  },
  {
    id: 2,
    name: 'Prof. P. A. Jayantha',
    title: 'Dean',
    org: 'Faulty of Science, University of Ruhuna',
    desc: 'Really amazing communication skills. Always understand what I am trying to achieve. Also, his work is really amazing. Do really high-quality work.',
  },
  {
    id: 3,
    name: 'H. A. U. Gunasekara',
    title: 'Principal',
    org: 'Royal College, Colombo-07',
    desc: 'Really hard-working person. Delivered the work as promised. Planning to work more with this person.',
  },
];
export default testimonials;
